export default __webpack_public_path__ + "static/media/camera-capture-sound.5f6a22ac.wav";